export const MENU_ITEMS = [
  { name: 'Home', page: 'home' },
  { name: 'Browse Cars', page: 'listings' },
  { name: 'How it Works', page: 'how-it-works' },
  { name: 'About Us', page: 'about' },
] as const;

export const CONTACT_INFO = {
  phone: '+1 (437) 887-1015',
  email: 'Contact@sayaara.com',
} as const;

export const QUICK_LINKS = [
  { name: 'About Us', page: 'about' },
  { name: 'How It Works', page: 'how-it-works' },
  { name: 'Browse Cars', page: 'listings' }
] as const;

export const LEGAL_LINKS = [
  { name: 'Terms & Conditions', action: 'terms' },
  { name: 'Privacy Policy', action: 'privacy' },
  { name: 'FAQs', action: 'faqs' }
] as const;